<template>
  <div class="Sniffer">
    <div class="Sniffer__content">
      <div class="Sniffer__bar" />
      <div class="Sniffer__browser">
        {{ trans('browser') }}
      </div>
      <div class="Sniffer__update">
        {{ trans('update') }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Sniffer',
    translations: {
      en: {
        browser: 'Your version of browser is too old.',
        update: 'Update your browser and reload the page.'
      },
      fr: {
        browser: 'Votre version de navigateur est dépassée.',
        update: 'Mettez à jour votre navigateur et rechargez la page.'
      },
    }
  }
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Sniffer
  background-color #fc1f1f
  position fixed
  z-index 999
  height 100%
  width 100%
  text-align center
  color #fff

  &__content
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    +max-screen(phone)
      margin-top 20px

  &__bar
    background  #fff
    height 170px
    width 680px
    margin 0 auto
    +max-screen(phone)
      height 80px
      width 310px

  &__browser
    font-size 40px
    line-height 45px
    font-family Inknut
    margin 40px 0
    +max-screen(phone)
      font-size 20px
      line-height 25px
      margin 20px 0

  &__update
    font-family Montserrat
    font-size 16px
    +max-screen(phone)
      font-size 11px
</style>



// WEBPACK FOOTER //
// src/components/sniffer/Sniffer.vue